import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { copyShift, clearCopy } from "../../Store/Actions/copyActions";
import { toast } from "react-toastify";
import { setSelectedUser } from "../../Store/Actions/shiftActions";

import { typeStyles, statusStyles } from "../../Utils/const";
import { useLocation } from "react-router-dom";

export default function ShiftTag({
  _id,
  userID,
  startTime,
  breakEndTime,
  breakStartTime,
  endTime,
  name = "Vincent",
  openDialog,
  openModifyDialog,
  published,
  type,
  next,
  status,
  location, // ! Only in Locations
  locationID, // ! Only in Locations
}) {
  const dispatch = useDispatch();
  const _location = useLocation();
  const shiftTagRef = useRef();

  const [small, setSmall] = useState(false);
  const selectedUserID = useSelector((state) => state.shift).selectedUserID;

  const [showDrawer, setShowDrawer] = useState(false);
  const currentIrelandTime = useSelector((state) => state.time).time;

  useEffect(() => {
    let width = shiftTagRef.current.offsetWidth;
    setSmall(width < 90);
  }, [shiftTagRef?.current?.offsetWidth]);

  // Helper to get full name (first name + last name)
  const getUserFullName = (user) => {
    if (!user) return "";
    const firstName = user.firstName || "";
    const lastName = user.lastName || "";
    return `${firstName} ${lastName}`.trim() || user.preferredName || "";
  };

  const formatHour24 = (date) => {
    date = new Date(date);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${paddedHours}:${paddedMinutes}`;
  };

  const timeFormat = (timeStr) => {
    const time = new Date(timeStr);
    time.setFullYear(time.getUTCFullYear());
    time.setMonth(time.getUTCMonth());
    time.setDate(time.getUTCDate());
    time.setHours(time.getUTCHours());
    time.setMinutes(time.getUTCMinutes());
    time.setSeconds(time.getUTCSeconds());
    return time;
  };

  const compareWithCurrentTime = (timeStr) => {
    let startTime = timeFormat(timeStr);
    let currentTime = timeFormat(currentIrelandTime);
    // console.log("Strat Time: ", timeStr);
    // console.log("Current Time: ", currentIrelandTime);
    // console.log(currentTime - startTime);
    // console.log(currentTime - startTime > 15 * 60 * 1000);

    return currentTime - startTime > 15 * 60 * 1000;
  };

  const hasPassedEndTime = () => {
    if (!endTime) return false;
    let scheduledEndTime = timeFormat(endTime);
    let currentTime = timeFormat(currentIrelandTime);
    return currentTime > scheduledEndTime;
  };

  const onDragStart = (e) => {
    const updatedData = {
      userID: userID?._id ?? type,
      startTime,
      endTime,
      breakStartTime,
      breakEndTime,
      locationID: locationID?._id,
      scheduleID: _id,
    };

    const sendDataToCell = {
      type: "update",
      updatedData,
    };

    e.dataTransfer.setData("application/json", JSON.stringify(sendDataToCell));
  };

  const handleClickCopy = (e) => {
    e.stopPropagation();

    const copyData = {
      userID: userID?._id ?? userID,
      locationID: locationID?._id,
      startTime: new Date(startTime).toISOString(),
      endTime: new Date(endTime).toISOString(),
      breakStartTime: breakStartTime
        ? new Date(breakStartTime).toISOString()
        : null,
      breakEndTime: breakEndTime ? new Date(breakEndTime).toISOString() : null,
      type: type,
    };

    // alert(JSON.stringify(copyData, null, 2));
    // dispatch(clearCopy());

    dispatch({
      type: "COPY_SHIFT",
      payload: copyData,
    });

    toast.info("Shift copied!");
  };

  const handleClickShift = (e) => {
    e.stopPropagation();
    dispatch(setSelectedUser(userID?._id));
  };

  // Get style for current type, fallback to default
  const typeStyle = typeStyles[type] || typeStyles.default;

  const statusStyle = statusStyles[status] || statusStyles.default;

  const hashStringToNumber = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  };

  const intToRGB = (i) => {
    const c = (i & 0x00ffffff).toString(16).toUpperCase();
    return "00000".substring(0, 6 - c.length) + c;
  };

  // Convert hex color to RGB components
  const hexToRgb = (hex) => {
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  };

  const stringToColorWithOpacity = (str, opacity = 0.1) => {
    const hash = hashStringToNumber(str);
    const hex = intToRGB(hash);
    const { r, g, b } = hexToRgb(hex);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  return (
    <div
      draggable={
        type !== "leave" && type !== "unavailable" && status !== "approved"
      }
      onDragStart={onDragStart}
      className={`relative  ${
        !small && "pl-2"
      }  overflow-hidden min-h-16 py-0.5 mb-1 ${
        type === "leave" || type === "unavailable"
          ? "border"
          : !published
          ? "border border-dashed"
          : "border"
      } cursor-pointer rounded-lg text-xs transition-all duration-150 hover:shadow-md hover:brightness-95 z-2 ${
        typeStyle.bg
      } ${
        selectedUserID == userID?._id
          ? "bg-gray-100 border-gray-500 border-2"
          : typeStyle.border
      } ${typeStyle.text} ${
        type === "leave" || type === "unavailable"
          ? "cursor-not-allowed opacity-80"
          : ""
      }`}
      ref={shiftTagRef}
      style={{
        backgroundColor: userID?.color + "20",
      }}
    >
      {/* Time display */}
      <div
        className={`font-semibold ${
          small ? "text-[10px] leading-[0.9] ml-1" : "text-xs"
        } text-wrap`}
      >
        {formatHour24(startTime) === "00:00" &&
        formatHour24(endTime) === "00:00" ? (
          <span>All Day</span>
        ) : (
          <div className="flex items-start">
            {formatHour24(startTime)}
            {small ? <br /> : <span> - </span>}
            {formatHour24(endTime)}
            {next && (
              <div className="rounded-full -ml-[8px] bg-red-600 w-2 h-2"></div>
            )}
          </div>
        )}
      </div>

      {_location.pathname === "/" && (
        <div
          className={`${
            small ? "text-[10px] ml-1" : "text-[12px]"
          } text-nowrap overflow-hidden`}
        >
          {getUserFullName(userID)}
        </div>
      )}

      {/* Location or user */}
      <div
        className={`${
          small ? "text-[10px] ml-1" : "text-[12px]"
        } text-nowrap overflow-hidden`}
      >
        {location ? locationID?.name : getUserFullName(userID)}
      </div>

      {/* Type tag (right bottom corner) */}
      {typeStyle.tag && (
        <div
          className={`absolute right-1 bottom-1 font-semibold flex items-center px-1 py-0.5 rounded ${
            small ? "text-[7px]" : "text-[9px]"
          } shadow ${typeStyle.tag.tagBg} ${typeStyle.tag.tagText}`}
          style={{ lineHeight: "1" }}
        >
          {typeStyle.tag.icon}
          {typeStyle.tag.label}
        </div>
      )}

      {/* Border */}
      {locationID?.color && (
        <div
          className={`absolute ${
            small
              ? "-bottom-1 w-full h-2 border-b-[9px]"
              : "-left-1 top-0 w-2 h-full border-l-[9px]"
          }`}
          style={locationID?.color ? { borderColor: locationID.color } : {}}
        ></div>
      )}

      {/* Status tag (left bottom corner) */}
      {statusStyle.tag?.label && (
        <div
          className={`absolute ${
            small && status == "approved" ? "-right-0.5" : "right-1"
          } ${
            small ? "bottom-1" : "top-1"
          } font-semibold flex items-center px-1 py-0.5 rounded ${
            small ? "text-[7px]" : "text-[9px]"
          } shadow ${statusStyle.tag.tagBg} ${statusStyle.tag.tagText}`}
          style={{ lineHeight: "1" }}
        >
          {statusStyle.tag.icon}
          {statusStyle.tag.label}
        </div>
      )}

      {compareWithCurrentTime(startTime) && status == "created" && (
        <div
          className={`absolute right-1 ${
            !statusStyle.tag?.label ? "top-1" : "top-[18px]"
          } font-semibold flex items-center px-1 py-0.5 rounded ${
            small ? "text-[7px]" : "text-[9px]"
          } shadow bg-orange-400 text-white`}
          style={{ lineHeight: "1" }}
        >
          LATE
        </div>
      )}

      {hasPassedEndTime() && status == "created" && type !== "leave" && type !== "unavailable" && (
        <div
          className={`absolute right-1 ${
            !statusStyle.tag?.label && !compareWithCurrentTime(startTime) 
              ? "top-1" 
              : compareWithCurrentTime(startTime) 
              ? "top-[34px]" 
              : "top-[18px]"
          } font-semibold flex items-center px-1 py-0.5 rounded ${
            small ? "text-[7px]" : "text-[9px]"
          } shadow bg-red-500 text-white`}
          style={{ lineHeight: "1" }}
        >
          PASSED
        </div>
      )}

      {/* Copy Icon (top right corner) */}
      {status == "created" &&
        type !== "leave" &&
        type !== "unavailable" &&
        _location.pathname != "/" && (
          <div className="absolute bottom-0 w-full h-full bg-transparent">
            {/* Right hover area (only triggers drawer, doesn't block parent clicks otherwise) */}
            <div
              className="absolute bottom-0  h-4 w-full z-20"
              style={{
                pointerEvents: showDrawer ? "auto" : "auto", // always clickable for drawer activation
              }}
              onMouseEnter={() => setShowDrawer(true)}
              onMouseLeave={() => setShowDrawer(false)}
            ></div>

            {/* Drawer (only blocks clicks when shown) */}
            <div
              onClick={handleClickShift}
              className={`
            absolute top-3 h-12 flex ${
              small && "flex-wrap"
            } w-full items-end justify-center z-30
            transition-opacity duration-200
            ${
              showDrawer
                ? "opacity-100 pointer-events-auto"
                : "opacity-0 pointer-events-none"
            }
          `}
              // style={{ minWidth: "60px" }}
              onMouseEnter={() => setShowDrawer(true)}
              onMouseLeave={() => setShowDrawer(false)}
            >
              <button
                onClick={
                  type !== "leave" && type !== "unavailable"
                    ? openModifyDialog
                    : null
                }
                className="mr-1 px-1 py-0.5 rounded ${small? 'text-[7px]' : 'text-[9px]'} font-semibold bg-white hover:bg-gray-100 transition-colors duration-150 cursor-pointer shadow"
              >
                EDIT
              </button>
              <button
                onClick={handleClickCopy}
                className="px-1 py-0.5 rounded ${small? 'text-[7px]' : 'text-[9px]'} font-semibold bg-white hover:bg-gray-100 transition-colors duration-150 cursor-pointer shadow"
              >
                COPY
              </button>
            </div>
          </div>
        )}
    </div>
  );
}
